// Filter that allows angular expressions and has lodash(_) in its context

// It converts angular expression to a function, 
// and then delegates to the default angular 'filter' with this function

// Usage: 
// $scope.items = [{a: 1}, {a: {b: 1}}, {a: {b: 2}}, {a: 2}, {a: 3}];
// $scope.scopeValue = 2;
// ng-repeat="item in items | apExprFilter:'!_.isObject($exprItem.a)'"
// => [{a: 1}, {a: 2}, {a: 3}]
// ng-repeat="item in items | apExprFilter:'_.isObject($exprItem.a)'"
// => [{a: {b: 1}}, {a: {b: 2}}]

// Parameterized (because this filter doesn't know anything about the scope, and it shouldn't, but if we pass values in, then it can use those):
// Array:
// $0, $1, $2, etc. are locals to the expression that correspond to the other values in the array in order
// ng-repeat="item in items | apExprFilter:['$exprItem.a === $0', scopeValue]"
// => '$exprItem.a === 2'
// => [{a: 2}]
// Object:
// the expression should be expr property of object, the other properties become locals to the expression
// ng-repeat="item in items | apExprFilter:{expr: '$exprItem.a === someProperty', someProperty: scopeValue}"
// => '$exprItem.a === 2'
// => [{a: 2}]

angular.module('aprima-core').filter('apExprFilter', ['filterFilter', '$parse', '_', function(filter, $parse, _) {
    'use strict';

    var localKeyPrefix = '$';
    var localItemKey = '$exprItem';
    var exprKey = 'expr';

    return _filter;

    function _filter() {
        var locals = {
            _: _
        };
        var expressionDefinition = arguments[1];
        var parsedExpression;

        if(_.isArray(expressionDefinition)) {
            parsedExpression = $parse(expressionDefinition[0]);
            _(expressionDefinition).tail().forEach(function(value, index) {
                locals[localKeyPrefix + index] = value;
            });
        }
        else if(_.isObject(expressionDefinition)) {
            parsedExpression = $parse(expressionDefinition[exprKey]);
            delete expressionDefinition[exprKey];
            _.assign(locals, expressionDefinition);
        }
        else {
            parsedExpression = $parse(expressionDefinition);
        }

        arguments[1] = filterExpression;
        return filter.apply(null, arguments);

        function filterExpression(value) {
            locals[localItemKey] = value;
            return parsedExpression(locals);
        }
    }
}]);
